import moment from 'moment';
import calendarConfig from './calendarConfig';

function formatMomentToDate(mom) {
	if (!mom.isValid()) {
		return;
	}

	return mom.format('MMM Do, YYYY');
}

function formatMomentToTime(mom) {
	if (!mom.isValid()) {
		return;
	}

	const hour = mom.format('HH');
	const minutes = mom.format('mm');
	//const ampm = mom.format('a').charAt(0);
	//return minutes === '00' ? `${hour}` : `${hour}:${minutes}`;
	return `${hour}:${minutes}`;
}

export const formatUtcDateTimeToDate = (dateTime) => {
	if (!dateTime) {
		return;
	}
	return formatMomentToDate(moment.utc(dateTime));
};

export const formatConfigDateToDate = (date) => {
	if (!date) {
		return;
	}
	return formatMomentToDate(moment.tz(`${date} 12:00:00`, calendarConfig.timezone));
};

export const formatConfigDateTimeToTime = (dateTime) => {
	if (!dateTime) {
		return;
	}
	return formatMomentToTime(moment.tz(dateTime, calendarConfig.timezone));
};
export const formatConfigTimeToTime = (time) => {
	if (!time) {
		return '?';
	}
	return formatMomentToTime(moment.tz(`2019-06-01 ${time}`, calendarConfig.timezone));
};
